export default __webpack_public_path__ + "images/trolley_cabin_baggage.da55980.svg";